import Api from '@/services/Api';

export default {
  register(data: { userName: string, firstName?: string, lastName?: string, email: string, password: string }) {
    const headers = {
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'application/json',
    };
    const token = window.localStorage.getItem('token');
    if (token) {
      // @ts-ignore
      headers['Authorization'] = 'bearer ' + window.localStorage.getItem('token');
    }
    return Api().post('users/register', data, {
      headers
    });
  },
  login(data: { email: string, password: string }) {
    return Api().post('users/login', data, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-type': 'application/json'
      }
    });
  }
};
